// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2k4Gk","choiceBoxes":"toolbarselects_choiceBoxes__2RQzc","simpleField":"toolbarselects_simpleField__S_6Z-"};